<template>
<transition name="sm-fade">
  <div v-if="visible" class="sm-mask" @click.self="close">
    <div class="sm-modal">
      <div class="sm-head">
        <span class="sm-flag">完成</span>
        <span class="sm-mode">{{ title }}</span>
      </div>

      <div class="sm-time">
        <span class="num">{{ time.toFixed(1) }}</span>
        <span class="unit">秒</span>
      </div>

      <div class="sm-percent" :class="{'first': first}">
        <template v-if="first">首次挑战记录</template>
        <template v-else>超越了 <b>{{ percentile }}</b>% 的历史成绩</template>
      </div>

      <div class="sm-hist">
        <div class="sm-hist-title">最近 5 次成绩</div>
        <ol class="sm-list">
          <li v-for="(r, i) in records" :key="i" :class="{'is-new': i === 0}">
            <span class="rank">{{ i + 1 }}</span>
            <span class="htime">{{ r.toFixed(1) }} s</span>
          </li>
        </ol>
        <div class="sm-empty" v-if="!records.length">暂无记录</div>
      </div>

      <button class="sm-btn" @click="close">再来一次</button>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  name: 'score-modal',
  props: {
    visible: { type: Boolean, default: false },
    time: { type: Number, default: 0 },
    records: { type: Array, default: () => [] },
    percentile: { type: Number, default: 0 },
    first: { type: Boolean, default: false },
    title: { type: String, default: '' }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.sm-mask{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  box-sizing: border-box;
}
.sm-modal{
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 14px;
  padding: 22px 22px 18px;
  box-sizing: border-box;
  box-shadow: 0 8px 30px rgba(0,0,0,0.25);
}
.sm-head{
  display: flex;
  align-items: center;
  gap: 10px;
}
.sm-flag{
  background: #4caf50;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: bold;
}
.sm-mode{
  color: #888;
  font-size: 13px;
}
.sm-time{
  margin-top: 10px;
  display: flex;
  align-items: baseline;
  gap: 4px;
  color: #2196f3;
  .num{
    font-size: 40px;
    font-weight: bold;
    line-height: 1;
  }
  .unit{
    font-size: 16px;
  }
}
.sm-percent{
  margin-top: 8px;
  font-size: 14px;
  color: #333;
  b{
    color: #ff7a00;
    font-size: 18px;
  }
  &.first{
    color: #888;
  }
}
.sm-hist{
  margin-top: 16px;
  border-top: 1px dashed #e0e0e0;
  padding-top: 12px;
}
.sm-hist-title{
  font-size: 13px;
  color: #888;
  margin-bottom: 8px;
}
.sm-list{
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  li{
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #555;
    .rank{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #eee;
      color: #888;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .htime{
      font-variant-numeric: tabular-nums;
    }
    &.is-new{
      .rank{
        background: #2196f3;
        color: #fff;
      }
      color: #2196f3;
      font-weight: bold;
    }
  }
}
.sm-empty{
  font-size: 13px;
  color: #aaa;
}
.sm-btn{
  margin-top: 18px;
  width: 100%;
  padding: 11px;
  font-size: 15px;
  background: #2196f3;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  &:active{
    background: #1e88e5;
  }
}
.sm-fade-enter-active, .sm-fade-leave-active{
  transition: opacity 0.2s;
}
.sm-fade-enter, .sm-fade-leave-to{
  opacity: 0;
}
</style>
